/**
 * Created by admin on 2018/5/18.
 */
import { Base64 } from 'js-base64';
import { message } from 'antd';
import { PATHS, RES_STATUS } from '../utils/constants';
import { getZoneTreeData } from '../services/calender';
import moment from 'moment';

export default {
  namespace: 'roomZone',
  state: {
    zone: null //用户权限范围内的可用区域
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getZone({}, { select, put, call }) {
      const { locale } = yield select(state => state.i18n);
      const { data, status, msg } = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 1, //只查区域
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale
      });
      if (status === RES_STATUS.success) {
        yield put({ type: 'update', payload: { zone: data } });
      } else {
        message.error(msg);
      }
    }
  },
  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.personal || pathname === PATHS.meeting) {
          dispatch({ type: 'getZone' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/roomZone.js